import React from 'react';

function TabListLine(): React.JSX.Element {
    return (
        <div className="absolute left-0 bottom-0 w-full">
            <div className="-mt-2 border-b-2 border-color-[rgba(var(--on-background-color-rgb),0.2)]" />
        </div>
    );
}

export default TabListLine;
